{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -66.89169962029709,
              44.77823199043826
            ],
            [
              -67.06295434788478,
              44.51933379846167
            ],
            [
              -65.46815387526351,
              43.22311724881456
            ],
            [
              -59.401522164004916,
              45.52213664590528
            ],
            [
              -59.80042579652985,
              47.18754923560499
            ],
            [
              -61.08455314791894,
              47.11846102143562
            ],
            [
              -61.95636288317931,
              46.09592537849821
            ],
            [
              -63.25833113625511,
              45.96723735316317
            ],
            [
              -63.92499039868629,
              46.039867188856874
            ],
            [
              -66.89169962029709,
              44.77823199043826
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}